export default function Training() {
  const programs = [
    {
      title: 'AI/ML Fundamentals',
      duration: '8 Weeks',
      icon: 'ri-brain-line',
      image: 'https://public.readdy.ai/ai/img_res/2a9112a3c20657a40175d507e7d3e426.jpg',
      features: [
        'Machine Learning Algorithms',
        'Deep Learning Fundamentals',
        'Model Training & Optimization',
        'Real-world Project Implementation',
        'Industry Best Practices'
      ]
    },
    {
      title: 'Gen-AI & RAG',
      duration: '6 Weeks',
      icon: 'ri-magic-line',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20illustration%20of%20generative%20AI%20technology%20with%20abstract%20representations%20of%20language%20models%2C%20data%20retrieval%20systems%2C%20and%20knowledge%20graphs%20in%20vibrant%20teal%20and%20cyan%20gradients%2C%20showing%20information%20flow%20and%20content%20generation%20processes%2C%20modern%20tech%20aesthetic%20with%20glowing%20neural%20pathways%20and%20digital%20elements%2C%20clean%20minimalist%20design&width=600&height=300&seq=training-genai-001&orientation=landscape',
      features: [
        'Generative AI Principles',
        'RAG Architecture & Implementation',
        'Prompt Engineering',
        'Vector Databases',
        'Production Deployment'
      ]
    },
    {
      title: 'Agentic-AI',
      duration: '10 Weeks',
      icon: 'ri-robot-2-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20illustration%20of%20autonomous%20AI%20agents%20and%20intelligent%20automation%20systems%20with%20robotic%20elements%2C%20decision-making%20flowcharts%2C%20and%20multi-agent%20collaboration%20visualization%20in%20teal%20and%20cyan%20color%20scheme%2C%20showing%20autonomous%20systems%20working%20together%20with%20interconnected%20pathways%2C%20professional%20tech%20design%20with%20clean%20geometric%20shapes%20and%20glowing%20accents&width=600&height=300&seq=training-agentic-001&orientation=landscape',
      features: [
        'Autonomous Agent Design',
        'Multi-Agent Systems',
        'Decision Making Algorithms',
        'Agent Orchestration',
        'Enterprise Integration'
      ]
    }
  ];

  return (
    <section id="training" className="py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(20,184,166,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(20,184,166,0.1) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-cyan-600 text-sm font-semibold tracking-wider uppercase mb-3">
            TRAINING PROGRAMS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Master AI & Machine Learning
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Industry-leading training in AI/ML, Gen-AI, RAG, and Agentic-AI with hands-on project experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden border-2 border-transparent hover:border-teal-500 transition-all duration-300 shadow-lg hover:shadow-2xl cursor-pointer group"
            >
              {/* Image Banner */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src={program.image}
                  alt={program.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>

              {/* Icon Badge */}
              <div className="relative -mt-10 flex justify-center">
                <div className="w-20 h-20 rounded-full bg-white shadow-xl flex items-center justify-center border-4 border-white">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center">
                    <i className={`${program.icon} text-3xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 pt-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">{program.title}</h3>
                <div className="flex justify-center mb-6">
                  <span className="px-4 py-1 bg-teal-50 text-teal-700 text-sm font-semibold rounded-full">
                    {program.duration}
                  </span>
                </div>

                <ul className="space-y-3 mb-8">
                  {program.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm text-gray-700">
                      <i className="ri-check-double-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button className="w-full py-3 bg-gradient-to-r from-teal-500 to-cyan-600 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-cyan-700 transition-all cursor-pointer whitespace-nowrap">
                  Enroll Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            We also provide custom AI/ML project development and consulting services
          </p>
          <button className="px-8 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-lg hover:bg-teal-600 hover:text-white transition-all cursor-pointer whitespace-nowrap">
            Discuss Your Project
          </button>
        </div>
      </div>
    </section>
  );
}
